import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-mini" }

import TableCellHeading from '@/design-system/atoms/TableCellHeading.vue'
import TableCellData from '@/design-system/atoms/TableCellData.vue'
import TableRow from '@/design-system/atoms/TableRow.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TableMini',
  props: {
    items: {},
    widthHeading1: {},
    widthHeading2: {},
    widthHeading3: {},
    widthHeading4: {},
    widthValue1: {},
    widthValue2: {},
    widthValue3: {},
    widthValue4: {},
    unlimitedLength: { type: Boolean }
  },
  emits: ["onClicked", "onHovered"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit

function handleSpaceKey(event: Event, item: any) {
  event.preventDefault() // Prevent space bar scrolling
  emits('onClicked', item)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      (_ctx.$slots.heading1)
        ? (_openBlock(), _createBlock(TableCellHeading, {
            key: 0,
            style: _normalizeStyle(_ctx.widthHeading1 ? `min-width: ${_ctx.widthHeading1}; width: ${_ctx.widthHeading1};` : '')
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "heading1")
            ]),
            _: 3
          }, 8, ["style"]))
        : _createCommentVNode("", true),
      (_ctx.$slots.heading2)
        ? (_openBlock(), _createBlock(TableCellHeading, {
            key: 1,
            style: _normalizeStyle(_ctx.widthHeading2 ? `min-width: ${_ctx.widthHeading2}; width: ${_ctx.widthHeading2};` : '')
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "heading2")
            ]),
            _: 3
          }, 8, ["style"]))
        : _createCommentVNode("", true),
      (_ctx.$slots.heading3)
        ? (_openBlock(), _createBlock(TableCellHeading, {
            key: 2,
            style: _normalizeStyle(_ctx.widthHeading3 ? `min-width: ${_ctx.widthHeading3}; width: ${_ctx.widthHeading3};` : '')
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "heading3")
            ]),
            _: 3
          }, 8, ["style"]))
        : _createCommentVNode("", true),
      (_ctx.$slots.heading4)
        ? (_openBlock(), _createBlock(TableCellHeading, {
            key: 3,
            style: _normalizeStyle(_ctx.widthHeading4 ? `min-width: ${_ctx.widthHeading4}; width: ${_ctx.widthHeading4};` : '')
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "heading4")
            ]),
            _: 3
          }, 8, ["style"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("tbody", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["list-group", { 'list-group__unlimited': _ctx.unlimitedLength }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createBlock(TableRow, {
            key: item,
            tabindex: "0",
            onClick: ($event: any) => (emits('onClicked', item)),
            onKeydown: [
              _withKeys(($event: any) => (emits('onClicked', item)), ["enter"]),
              _withKeys((event) => handleSpaceKey(event, item), ["space"])
            ],
            onMousemove: ($event: any) => (emits('onHovered', item))
          }, {
            default: _withCtx(() => [
              (_ctx.$slots.value1)
                ? (_openBlock(), _createBlock(TableCellData, {
                    key: 0,
                    style: _normalizeStyle(_ctx.widthValue1 ? `min-width: ${_ctx.widthValue1}; width: ${_ctx.widthValue1};` : '')
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "value1", { item: item })
                    ]),
                    _: 2
                  }, 1032, ["style"]))
                : _createCommentVNode("", true),
              (_ctx.$slots.value2)
                ? (_openBlock(), _createBlock(TableCellData, {
                    key: 1,
                    style: _normalizeStyle(_ctx.widthValue2 ? `min-width: ${_ctx.widthValue2}; width: ${_ctx.widthValue2};` : '')
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "value2", { item: item })
                    ]),
                    _: 2
                  }, 1032, ["style"]))
                : _createCommentVNode("", true),
              (_ctx.$slots.value3)
                ? (_openBlock(), _createBlock(TableCellData, {
                    key: 2,
                    style: _normalizeStyle(_ctx.widthValue3 ? `min-width: ${_ctx.widthValue3}; width: ${_ctx.widthValue3};` : '')
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "value3", { item: item })
                    ]),
                    _: 2
                  }, 1032, ["style"]))
                : _createCommentVNode("", true),
              (_ctx.$slots.value4)
                ? (_openBlock(), _createBlock(TableCellData, {
                    key: 3,
                    style: _normalizeStyle(_ctx.widthValue4 ? `min-width: ${_ctx.widthValue4}; width: ${_ctx.widthValue4};` : '')
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "value4", { item: item })
                    ]),
                    _: 2
                  }, 1032, ["style"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["onClick", "onKeydown", "onMousemove"]))
        }), 128))
      ], 2)
    ])
  ]))
}
}

})